/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Path
 */
export interface Path {
    /**
     * 
     * @type {string}
     * @memberof Path
     */
    path: string;
}

export function PathFromJSON(json: any): Path {
    return PathFromJSONTyped(json, false);
}

export function PathFromJSONTyped(json: any, ignoreDiscriminator: boolean): Path {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
    };
}

export function PathToJSON(value?: Path | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
    };
}


